// Global components registering
import Page from '@/components/layout/Page'
import PageBackground from '@/components/layout/PageBackground'
import MdIcon from '@/components/ui/MdIcon'
// Helpers
import helpers from '@/plugins/helpers'
// API client
import apiClient from '@arpej/apiclient'
// Core imports
import Vue from 'vue'
// Analytics
// import { VueReCaptcha } from 'vue-recaptcha-v3'
// Vue i18n
import VueI18n from 'vue-i18n'
import App from './App.vue'
import './assets/scss/main.scss'
import deviceUuid from './plugins/deviceUuid'
// Element UI
import './plugins/element'
// Error handling
import './plugins/errorHandling'
import { errorHandler } from './plugins/errorHandling'
import { defaultLocale, languages } from './plugins/i18n'
// Moment
import './plugins/moment'
import router from './router'
import store from './store'
Vue.config.productionTip = false
// DeviceUUID init
deviceUuid()

// APIClient init
export const api = apiClient.init({
  errorHandler: errorHandler,
  baseURL: process.env.VUE_APP_API_URL,
  clientId: process.env.VUE_APP_CLIENT_ID,
  clientSecret: process.env.VUE_APP_CLIENT_SECRET,
  deviceUuid: localStorage.getItem('devideUuid')
})
Vue.use(apiClient, api)

// Vue.use(VueReCaptcha, { 
//   siteKey: '6Lf2RI8iAAAAAODDOgrsLxFpcXcEqyxL33vdGNjZ',
//   loaderOptions: {
//     useEnterprise: true,
//     autoHideBadge: false,
//     explicitRenderParameters: {
//       badge: 'inline',
//       container: 'recaptcha-badge'
//     }
//   }
//  })

// Vue i18n
Vue.use(VueI18n)
const messages = Object.assign(languages)
export const i18n = new VueI18n({
  locale: defaultLocale,
  fallbackLocale: 'fr',
  silentTranslationWarn: true,
  messages
})

// Helpers
Vue.use(helpers)

// Global components
Vue.component('page', Page)
Vue.component('page-background', PageBackground)
Vue.component('md-icon', MdIcon)

// Instance init
const init = async () => {
  // Init offline token before anything else
  await api.getOfflineToken()

  // Restore session in case localStorage isn't empty
  await store.dispatch('auth/restoreSession')

  // Vue initialization
  new Vue({
    router,
    store,
    i18n,
    render: h => h(App)
  }).$mount('#app')
}

// Start the Vue instance
init()
